import React from 'react';
import { FormattedMessage } from 'react-intl';
import Label from './label'

class Authorized extends React.Component {

    render() {
        return <div>
            { !this.props.authorized && <h2><Label>app.unauthorized</Label></h2> }
        </div>
    }
}

export default Authorized;
